import { render, staticRenderFns } from "./StoreTransfers.vue?vue&type=template&id=1416cf84&scoped=true&"
import script from "./StoreTransfers.vue?vue&type=script&lang=js&"
export * from "./StoreTransfers.vue?vue&type=script&lang=js&"
import style0 from "./StoreTransfers.vue?vue&type=style&index=0&id=1416cf84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1416cf84",
  null
  
)

export default component.exports